import { useEffect, useState } from 'react';
import ApiClient from '../../config/api';
import isIranNightTime from '../../utils/isIranNightTime';

// CMS content-list endpoint. The on/off switch is the `isActive` flag on
// the (single) content item tagged with this slug.
const NIGHT_RESTRICTION_CONFIG_ENDPOINT =
  'https://api.postex.ir/api/app/v1/cms/shipito-night-restriction';

const RECHECK_INTERVAL_MS = 60 * 1000;

// Fetches the remote on/off flag once, then (only while it's on) re-checks
// the Iran-time clock every minute so a user already inside the app gets
// blocked right at 22:00 without needing to reload.
export default function useNightAccessRestriction() {
  const [featureEnabled, setFeatureEnabled] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchFlag = async () => {
      try {
        const api = ApiClient();
        const response = await api.get(NIGHT_RESTRICTION_CONFIG_ENDPOINT);
        const items = response?.data?.data;
        const isActive = Array.isArray(items) && Boolean(items[0]?.isActive);
        if (!cancelled) {
          setFeatureEnabled(isActive);
        }
      } catch (error) {
        // Fail open: if the flag can't be fetched, don't lock users out.
        console.error('Failed to fetch night restriction flag:', error);
        if (!cancelled) {
          setFeatureEnabled(false);
        }
      }
    };

    fetchFlag();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!featureEnabled) {
      setIsBlocked(false);
      return undefined;
    }

    const evaluate = () => setIsBlocked(isIranNightTime());
    evaluate();

    const intervalId = setInterval(evaluate, RECHECK_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [featureEnabled]);

  return isBlocked;
}
